import type { TMessages } from '@/types/TMessages'

export const messages = { header: 'Лучшие предложения для закупки сельхозтоваров' } satisfies TMessages
